// src/services/saveService.js
import DataService from "services/DataService";
import { formatBackDate } from "../utils/Formatter";
import constantsAutomaton from "../constants/alertsInputAutomaton";
import constantsGrammar from "../constants/Grammar/inputGrammar";
import constantsValidate from "../constants/Feedback/validationAutomata";
import validations from "../utils/validationsMachine";

export async function saveMachine({
  dot,
  dotName,
  createdDate,
  credential,
  user,
  setUser,
  setAlert,
  setCreatedDate,
  language,
  isAutoSave = false,
}) {
  try {
    const isValid = validations.isValidMachine(dot);
    if (!isValid.valid) {
      setAlert({
        active: true,
        text:
          isValid.message[language] +
          ", " +
          constantsValidate.validMachine.error.afterMessage[language],
        color: "info",
        severity: "info",
      });
      return;
    }
    if (
      !dot ||
      dot.trim() === "digraph G { }" ||
      dot.trim().replace(/\s+/g, "") === "digraphG{}"
    ) {
      setAlert({
        active: true,
        text: constantsAutomaton.alerts.info.withoutData[language],
        color: "warning",
        severity: "info",
      });
      return;
    }

    const dateNow = new Date().toISOString();
    const authorization = { headers: { Authorization: credential } };
    const param = { variables: dot, name: dotName };

    const existingIndex = user.historicalMachine.findIndex(
      (item) => item.createdDate === createdDate
    );

    if (existingIndex !== -1) {
      const response = await DataService.updateHistoricalMc(
        user.email,
        param,
        formatBackDate(createdDate),
        authorization
      );

      setUser((prevUser) => ({
        ...prevUser,
        historicalMachine: prevUser.historicalMachine.map((entry) =>
          entry.createdDate === createdDate
            ? {
                ...entry,
                variables: dot,
                lastUpdatedDate: dateNow,
                name: response.data.name,
              }
            : entry
        ),
      }));

      setCreatedDate(response.data.createdDate);
      let text;
      if (isAutoSave) {
        text = constantsAutomaton.infos.autoUpdated[language];
      } else {
        text = constantsAutomaton.infos.updated[language];
      }
      setAlert({
        active: true,
        text: text,
        color: "success",
      });
    } else {
      const saveResponse = await DataService.postSaveHistoricalMc(
        user.email,
        param,
        authorization
      );
      const createdDateFormatted = saveResponse.data.createdDate.slice(0, 23);

      setUser((prevUser) => ({
        ...prevUser,
        historicalMachine: [
          {
            variables: dot,
            lastUpdatedDate: dateNow,
            createdDate: createdDateFormatted,
            name: saveResponse.data.name,
          },
          ...prevUser.historicalMachine,
        ],
      }));

      setCreatedDate(createdDateFormatted);
      let text;
      if (isAutoSave) {
        text = constantsAutomaton.infos.autoCreate[language];
      } else {
        text = constantsAutomaton.infos.create[language];
      }
      setAlert({
        active: true,
        text: text,
        color: "success",
      });
    }
  } catch (e) {
    console.error("Erro ao salvar a máquina:", e);
  }
}

export async function saveGrammar({
  grammar,
  grammarName,
  grammarCreatedDate,
  credential,
  user,
  setUser,
  setAlert,
  setGrammarCreatedDate,
  language,
  isAutoSave = false,
}) {
  try {
    if (grammar.length === 0) {
      setAlert({
        active: true,
        text: constantsGrammar.alerts.info.withoutData[language],
        color: "warning",
        severity: "info",
      });
      return;
    }

    const dateNow = new Date().toISOString();
    const authorization = { headers: { Authorization: credential } };
    const param = { variables: grammar, name: grammarName };

    const existingIndex = user.historicalGrammar.findIndex(
      (item) => item.createdDate === grammarCreatedDate
    );

    if (existingIndex !== -1) {
      const response = await DataService.updateHistoricalGr(
        user.email,
        param,
        formatBackDate(grammarCreatedDate),
        authorization
      );

      setUser((prevUser) => ({
        ...prevUser,
        historicalGrammar: prevUser.historicalGrammar.map((entry) =>
          entry.createdDate === grammarCreatedDate
            ? {
                ...entry,
                variables: grammar,
                lastUpdatedDate: dateNow,
                name: response.data.name,
              }
            : entry
        ),
      }));

      setGrammarCreatedDate(response.data.createdDate);
      let text;
      if (isAutoSave) {
        text = constantsGrammar.alert.autoUpdate[language];
      } else {
        text = constantsGrammar.alert.update[language];
      }
      setAlert({
        active: true,
        text: text,
        color: "success",
      });
    } else {
      const saveResponse = await DataService.postSaveHistoricalGr(
        user.email,
        param,
        authorization
      );
      const createdDateFormatted = saveResponse.data.createdDate.slice(0, 23);

      setUser((prevUser) => ({
        ...prevUser,
        historicalGrammar: [
          {
            variables: grammar,
            lastUpdatedDate: dateNow,
            createdDate: createdDateFormatted,
            name: saveResponse.data.name,
          },
          ...prevUser.historicalGrammar,
        ],
      }));

      setGrammarCreatedDate(createdDateFormatted);
      let text;
      if (isAutoSave) {
        text = constantsGrammar.alert.autoSave[language];
      } else {
        text = constantsGrammar.alert.save[language];
      }
      setAlert({
        active: true,
        text: text,
        color: "success",
      });
    }
  } catch (e) {
    console.error("Erro ao salvar a gramática:", e);
  }
}
